import React from "react";
import "./index.css";
import App from "./App";
import {BrowserRouter} from "react-router-dom";
import {createRoot} from 'react-dom/client';
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";
import env from "react-dotenv";
import {Helmet, HelmetProvider} from 'react-helmet-async';

if (env.REACT_APP_STAGE !== "development" && env.REACT_APP_STAGE !== "local") {
    Sentry.init({
        dsn: "https://d5fff6495e498716722fd8f6073065e4@o320199.ingest.sentry.io/4506510561574912",
        integrations: [new Integrations.BrowserTracing()],
        environment: process.env.REACT_APP_STAGE,
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 0.2, // recommended to be a lower value in production
        // ignoreErrors: ["UnhandledRejection",],
        // Called for message and error events
        beforeSend(event) {
            // Modify or drop the event here
            if (['AxiosError', 'UnhandledRejection'].includes(event.exception.values[0].type)) {
                // console.log('dropping Sentry event')
                return null; // don't send this event
            }
            return event;
        },

    });
}

// Detect when the application is running inside a WordPress embed.
// In addition to the original `wp-embed=true` flag we also check for the
// presence of a `wp_token` query parameter or the `/embed` pathname so the
// iframe URL can simply be `/embed?wp_token=...`.
const searchParams = new URLSearchParams(window.location.search);
const isWpEmbed =
  window.location.pathname.startsWith('/embed') ||
  searchParams.has('wp_token') ||
  searchParams.get('wp-embed') === 'true';

if (isWpEmbed) {
    // Load WordPress embed version
    import('./wp_embed/index.js');
} else {
    // Load normal app (your existing code)
    // ... rest of your current index.js
    createRoot(document.getElementById("root")).render(<React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>);

}


